
export default {
  props: {
    items: {
      required: true,
      default: () => [],
      type: Array
    },
    fullwidth: {
      required: false,
      default: false,
      type: Boolean
    },
    defaultValue: {
      required: false,
      default: ['Alle typer'],
      type: Array
    },
    /**
     * If this is enabled, then the first item in the defaultValue prop is the select all option.
     */
    selectAllEnabled: {
        required: false,
        default: false,
        type: Boolean
    }
  },
  data() {
    return {
      currentItems: this.defaultValue,
      previousItems: this.defaultValue
    };
  },
  computed: {
    selectableItems() {
        return [this.defaultValue[0], ...this.items];
    },
  },
  methods: {
    changedValue(items) {
        if (this.selectAllEnabled) {
            const addedItem = this.currentItems.find(item => !this.previousItems.includes(item));
        
            // If the default value was clicked and other items are selected, reset to default value
            if (addedItem === this.defaultValue[0]) {
              this.currentItems = [this.defaultValue[0]];
            } 
            // If other items are clicked, remove the default value
            else if (this.currentItems.includes(this.defaultValue[0]) && this.currentItems.length > 1) {
              this.currentItems = this.currentItems.filter(item => item !== this.defaultValue[0]);
            }
        
            if (this.currentItems.length === 0) {
              this.currentItems = [this.defaultValue[0]];
            }
        
            this.previousItems = [...this.currentItems];
        }
        this.$emit('select-item', this.currentItems);
    }
  }
};
